import styled from 'styled-components';
import { // Reusing styles from CardModal and AddSubtaskModal for consistency
    ModalOverlay as BaseModalOverlay,
    ModalContent as BaseModalContent,
    ModalHeader as BaseModalHeader,
    ModalActions as BaseModalActions,
    SaveButton as BaseSaveButton, // Assuming 'Save' might be 'Set Parent'
    CancelButton as BaseCancelButton,
    FieldLabel as BaseFieldLabel, // If needed for any text
} from './AddSubtaskModal.styles'; // Or directly from CardModal.styles if more appropriate

import {
    StyledInput as BaseSearchInput, // For the search bar
    ParentDropdownList as BaseParentDropdownList, // List container
    ParentDropdownItem as BaseParentDropdownItem, // Individual item
    NoResultsMessage as BaseNoResultsMessage, // Message for no results
} from './CardModal.styles';


export const ModalOverlay = styled(BaseModalOverlay)``;
export const ModalContent = styled(BaseModalContent)`
    width: 520px; // Slightly wider for search results potentially
`;
export const ModalHeader = styled(BaseModalHeader)``;

export const SearchInput = styled(BaseSearchInput)`
    margin-bottom: 12px;
`;

export const ParentListContainer = styled.div`
    max-height: 300px; // Max height for the scrollable list
    overflow-y: auto;
    border: 1px solid #3B444C;
    border-radius: 3px;
    background: #22272B; // Background for the list area

    /* Custom Scrollbar Styles (can use className or direct styling) */
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }
    /* For Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const ParentListItem = styled(BaseParentDropdownItem)`
    // Inherits styles, can add overrides if needed
    // e.g., if selection state needs to be handled differently
`;

export const NoResultsMessage = styled(BaseNoResultsMessage)``;

export const ModalActions = styled(BaseModalActions)``;

// "Set Parent" button might not be needed if clicking an item directly sets it.
// If an explicit save button is used after selection, then:
// export const SetParentButton = styled(BaseSaveButton)``;
export const CancelButton = styled(BaseCancelButton)``;

// Export FieldLabel if used, for example, above the search input
export { BaseFieldLabel as FieldLabel };
